import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
// import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'
import {send} from '../../modules/media'
import {getAllStructures, getVisibleStructures} from '../../modules/structures'
import {withRouter} from 'react-router'
import Widget04 from './widget04'
import DatabaseIcon from 'react-icons/lib/fa/database'
import CloseIcon from 'react-icons/lib/md/close'
import { actions as notifActions } from 'redux-notifications'
import { runJoyride } from '../../modules/joyride'
import PropTypes from "prop-types";

import './home.css'

import {
  Collapse,
  Row,
  Col,
      Progress,
  Card,
  CardHeader,
  CardBody,
  CardGroup,
  CardFooter,
  CardTitle,
  Button
} from "reactstrap"

import { Line} from "react-chartjs-2"


// const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
// const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';


// sparkline charts
/* const sparkLineChartData = [
  {
    data: [35, 23, 56, 22, 97, 23, 64],
    label: 'New Clients'
  },
  {
    data: [65, 59, 84, 84, 51, 55, 40],
    label: 'Recurring Clients'
  },
  {
    data: [35, 23, 56, 22, 97, 23, 64],
    label: 'Pageviews'
  },
  {
    data: [65, 59, 84, 84, 51, 55, 40],
    label: 'Organic'
  },
  {
    data: [78, 81, 80, 45, 34, 12, 40],
    label: 'CTR'
  },
  {
    data: [1, 13, 9, 17, 34, 41, 38],
    label: 'Bounce Rate'
  }
/*
const makeSparkLineData = (dataSetNo, variant) => {
  const dataset = sparkLineChartData[dataSetNo];
  const data = {
    labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    datasets: [
      {
        backgroundColor: 'transparent',
        borderColor: variant ? variant : '#c2cfd6',
        data: dataset.data,
        label: dataset.label
      }
    ],
  };
  return () => data;
};

const sparklineChartOpts = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    xAxes: [{
      display: false,
    }],
    yAxes: [{
      display: false,
    }]
  },
  elements: {
    line: {
      borderWidth: 2
    },
    point: {
      radius: 0,
      hitRadius: 10,
      hoverRadius: 4,
      hoverBorderWidth: 3,
    }
  },
  legend: {
    display: false
  }
};
*/
// Main Chart

// convert Hex to RGBA
function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
}

//Random Numbers
function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

var elements = 27;
var data1 = [];
var data2 = [];
var data3 = [];

for (var i = 0; i <= elements; i++) {
  data1.push(random(50, 200));
  data2.push(random(80, 100));
  data3.push(65);
}




const mainChart = {
  labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S'],
  datasets: [
    {
      label: 'My First dataset',
      backgroundColor: convertHex(brandInfo, 10),
      borderColor: brandInfo,
      pointHoverBackgroundColor: '#fff',
      borderWidth: 2,
      data: data1
    },
    {
      label: 'My Second dataset',
      backgroundColor: 'transparent',
      borderColor: brandSuccess,
      pointHoverBackgroundColor: '#fff',
      borderWidth: 2,
      data: data2
    },
    {
      label: 'My Third dataset',
      backgroundColor: 'transparent',
      borderColor: brandDanger,
      pointHoverBackgroundColor: '#fff',
      borderWidth: 1,
      borderDash: [8, 5],
      data: data3
    }
  ]
}

const mainChartOpts = {
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  scales: {
    xAxes: [{
      gridLines: {
        drawOnChartArea: false,
      }
    }],
    yAxes: [{
      ticks: {
        beginAtZero: true,
        maxTicksLimit: 5,
        stepSize: Math.ceil(250 / 5),
        max: 250
      }
    }]
  },
  elements: {
    point: {
      radius: 0,
      hitRadius: 10,
      hoverRadius: 4,
      hoverBorderWidth: 3,
    }
  }
}

const { notifSend } = notifActions;

class Home extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      collapse: true
    };
  }

  toggle() {
    /*this.props.notifSend({
      message: <div className="card card-accent-warning">
        <div className="card-header">
          Card with accent
        </div>
        <div className="card-body">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex
          ea commodo consequat. <Link to="/about">About</Link>
        </div>
      </div>,
      dismissAfter: 300000
    });*/
    this.setState({
      collapse: !this.state.collapse
    });
  }

  launchPotentialTour() {

    console.log('c parti', this.refs, this.context, this.props);
    // this.context.joyrideProvider.joyride.reset(true);
    this.props.runJoyride();
  }

  render() {
    // const { props } = this;
    return (<div className="home container-fluid">
      <div className="animated fadeIn mt-4">
        <Row>
          <Col xs="12" sm="12" md="12">
            <Card className="border-0">
              <CardHeader className="bg-gray-400">
                <div style={{
                    color: 'white'
                }} className="float-right">
                  <CloseIcon className="float-right mt-1" onClick={this.toggle} size={38} style={{cursor:'pointer'}}/>
                </div>
                <h1 className="light text-white">Welcome to RS2E members !</h1>
              </CardHeader>
              <Collapse isOpen={this.state.collapse}>
                <CardBody className="card-body">
                  <h3 className="light">QCATS will help you to become a "computational chemist" with no need to acquire extended theoretical background...</h3>
                  <hr className="my-4"/>
                  <p className="lead">Currently on your platform:</p>
                  <ul className="lead">
                    <li>
                      Create a project by simply adding a cif file.
                    </li>
                    <li>
                      Access to structural properties (Relaxed structures, XRD patterns...)
                    </li>
                    <li>
                      Access to electronic properties (DOS, Atomic charges, Madelung potentials...)
                    </li>
                  </ul>
                  <br/>
                  <Row>
                    {/*<Col xs="12" sm="12" md="12">
                      <h2 className="mb-1 text-gray-800">Make a short tour</h2>
                      </Col>
                      <Col xs="12" sm="12" md="12">
                      <h4 className="mb-4 text-gray-400">Choose your operation and let you guide</h4>
                    </Col>*/}
                    <Col xs="12" sm="6" md="4" className="">
                      <Card className="bg-primary border-light h-100 mb-0">
                        <CardHeader className="text-white">
                          <Row className="no-gutters align-items-center">
                            <Col className="col-auto mr-3">
                              <img alt="" src="./images/potential.svg" style={{
                                  height: '30px'
                              }}/>
                            </Col>
                            <Col>
                              <span style={{
                                  fontSize: "1.2rem",
                                  fontWeight: 600,
                                  letterSpacing: -1
                              }}>Calculate a potential</span>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody className="card-body bg-gray-100  text-gray-900" style={{display: 'flex', flexDirection: 'column'}}>
                          <Row style={{flexGrow: 1}}>
                            <Col>
                              <img className="float-right" alt="" src="./images/Pot.png" style={{
                                  height: '50px'
                              }}/>
                              Compute the average potential of a material with respect to any counter-electrode using the Nernst equation
                            </Col>
                          </Row>
                          <Button type="link" color="primary" size="lg" className="btn btn-primary btn-lg btn-block mt-3 d-none" outline={true} onClick={this.launchPotentialTour.bind(this)}>LET'S GO !</Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs="12" sm="6" md="4">
                      <Card className="bg-success border-light h-100 mb-0">
                        <CardHeader className="text-white">
                          <Row className="no-gutters align-items-center" style={{flexGrow: 1}}>
                            <Col className="col-auto mr-3">
                              <img alt="" src="./images/structural.svg" style={{
                                height: '30px'
                              }}/>
                            </Col>
                            <Col>
                              <span style={{
                                fontSize: "1.2rem",
                                fontWeight: 600,
                                letterSpacing: -1
                              }} className="mb-0">Perform a structural relaxation</span>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody className="card-body bg-gray-100 text-gray-900" style={{display: 'flex', flexDirection: 'column'}}>
                          <Row style={{flexGrow: 1}}>
                            <Col>
                              <img className="float-right ml-2" alt="" src="./images/PES.png" style={{
                                height: 70
                              }}/>
                              Search for the best crystal structure that minimizes the Potential Energy Surface (PES) of a material.
                            </Col>
                          </Row>
                          <Button type="link" color="success" size="lg" className="btn btn-block mt-3 d-none" outline={true}>LET'S GO !</Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xs="12" sm="6" md="4">
                      <Card className="bg-info border-light h-100 mb-0">
                        <CardHeader className="text-white">
                          <Row className="no-gutters align-items-center">
                            <Col className="col-auto mr-3">
                              <DatabaseIcon style={{
                                  height: 24,
                                  width: 24
                              }}/>
                            </Col>
                            <Col>
                              <span style={{
                                  fontSize: "1.2rem",
                                  fontWeight: 600,
                                  letterSpacing: -1
                              }}>Explore database</span>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody className="card-body bg-gray-100 text-gray-900" style={{display: 'flex', flexDirection: 'column'}}>
                          <div style={{flexGrow: 1}}>
                            Explore the RS2E database of already computed materials and perform your own analyses.
                          </div>
                          <div>
                            <Button type="link" color="secondary" size="lg" className="btn btn-block mt-4 d-none" outline={true} disabled={true}>SOON AVAILABLE</Button>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
        {/*
          <CardGroup>
          <Widget04 icon="icon-people" color="info" header="87.500" value="25">Visitors</Widget04>
          <Widget04 icon="icon-user-follow" color="success" header="385" value="25">New Clients</Widget04>
          <Widget04 icon="icon-basket-loaded" color="warning" header="1238" value="25">Products sold</Widget04>
          <Widget04 icon="icon-pie-chart" color="primary" header="28%" value="25">Returning Visitors</Widget04>
          <Widget04 icon="icon-speedometer" color="danger" header="5:34:11" value="25">Avg. Time</Widget04>
          </CardGroup>
          <Row className="mt-3">
          <Col>
            <Card>
          <CardBody className="card-body">
          <Row>
          <Col sm="5">
          <CardTitle className="mb-0">Traffic</CardTitle>
          <div className="small text-muted">November 2015</div>
          </Col>
          <Col sm="7" className="d-none d-sm-inline-block">

          </Col>
          </Row>
          <div className="chart-wrapper" style={{
          height: 300 + 'px',
          marginTop: 40 + 'px'
          }}>
          <Line data={mainChart} options={mainChartOpts} height={300}/>
          </div>
          </CardBody>
          <CardFooter>
          <ul>
          <li>
          <div className="text-muted">Visits</div>
          <strong>29.703 Users (40%)</strong>
          <Progress className="progress-xs mt-2" color="success" value="40"/>
          </li>
          <li className="d-none d-md-table-cell">
          <div className="text-muted">Unique</div>
          <strong>24.093 Users (20%)</strong>
          <Progress className="progress-xs mt-2" color="info" value="20"/>
          </li>
          <li>
          <div className="text-muted">Pageviews</div>
          <strong>78.706 Views (60%)</strong>
          <Progress className="progress-xs mt-2" color="warning" value="60"/>
          </li>
          <li className="d-none d-md-table-cell">
          <div className="text-muted">New Users</div>
          <strong>22.123 Users (80%)</strong>
          <Progress className="progress-xs mt-2" color="danger" value="80"/>
          </li>
          <li className="d-none d-md-table-cell">
          <div className="text-muted">Bounce Rate</div>
          <strong>Average 40.15%</strong>
          <Progress className="progress-xs mt-2" color="primary" value="40"/>
          </li>
          </ul>
          </CardFooter>
            </Card>
          </Col>
          </Row>
          <div className="animated fadeIn mt-4">
          <Row className="bg-white pt-4 align-items-center">
            <Col xs="12" sm="12" md="12" className="text-center">
          <p>Should you have any request to improve this plateform DO NOT HESITATE to <a href="mailto:marie-liesse.doublet@umontpellier.fr">contact us</a>.</p>
            </Col>
            <Col xs="12" sm="6" md="4" className="text-center">
          <img alt="" src="/images/rs2e.jpg" style={{
          height: '200px'
          }}/>
            </Col>

            <Col xs="12" sm="6" md="4" className="text-center">
          <img alt="" src="/images/logo_grimauld.png" style={{
          height: '150px'
          }}/></Col>
            <Col xs="12" sm="6" md="4" className="text-center">
          <img alt="" src="/images/cnrs.png" style={{
          height: '150px'
          }}/></Col>
          </Row>
          </div>
        */}
      </div>
    </div>)
  }
}

Home.contextTypes = {
  joyrideProvider: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  return ({
    ...state.user,
    structures: getVisibleStructures(state.structures)
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({
  send,
  getAllStructures,
  notifSend,
  runJoyride
}, dispatch)


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home))



// WEBPACK FOOTER //
// ./src/containers/home/index.js